import request from "../../../../utils/api";

const url = "api/v1/companies";

export const getFinancialModel = (id, params) => {
  return request(`${url}/${id}/financial-model`, { params });
}


// WEBPACK FOOTER //
// ./src/modules/company/pages/financial-model/service.js